import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IS_POLLING_REQUEST } from './polling.context';

/**
 * Polling interceptor
 * Adds Session-Refresh: 0 header to polling requests to prevent session refresh
 */
@Injectable()
export class PollingInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const isPolling = request.context.get(IS_POLLING_REQUEST);

    if (!isPolling) {
      return next.handle(request);
    }

    const requestWithHeader = request.clone({
      setHeaders: {
        'Session-Refresh': '0',
      },
    });

    return next.handle(requestWithHeader);
  }
}
